const auth = {
    // Common
    email: 'Email',
    password: 'Password',
    submit: 'Invia',
    loading: 'Caricamento...',
    error: 'Errore',
    success: 'Successo',

    // Form validation
    emailRequired: 'L\'email è obbligatoria',
    emailInvalid: 'Inserisci un indirizzo email valido',
    passwordRequired: 'La password è obbligatoria',
    confirmPasswordRequired: 'Conferma la tua password',

    // OAuth
    continueWithGoogle: 'Continua con Google',
    orContinueWithEmail: 'Oppure continua con email',

    // Signup
    signup: 'Registrati',
    signupTitle: 'Registrazione',
    signupSubtitle: 'Crea un nuovo account',
    alreadyHaveAccount: 'Hai già un account?',
    loginLink: 'Accedi',
    signupSuccess: 'Registrazione completata con successo!',
    signupError: 'Errore durante la registrazione',
    login: 'Accedi',
    loginTitle: 'Accesso',
    loginSubtitle: 'Inserisci la tua email e password',
    dontHaveAccount: 'Non hai un account?',
    signupLink: 'Registrati',
    forgotPassword: 'Password dimenticata?',
    loginSuccess: 'Accesso completato con successo!',
    loginError: 'Errore durante l\'accesso',
    passwordReset: 'Reset Password',
    passwordResetTitle: 'Reset Password',
    passwordResetSubtitle: 'Inserisci la tua email per resettare la password',
    sendResetEmail: 'Invia Email Reset',
    backToLogin: 'Torna al Login',
    resetEmailSent: 'Email di reset inviata!',
    resetEmailError: 'Errore nell\'invio dell\'email di reset',
    newPassword: 'Nuova Password',
    confirmPassword: 'Conferma Password',
    resetPassword: 'Reset Password',
    resetting: 'Resettando...',
    passwordResetSuccess: 'Password resettata con successo! Reindirizzamento al login...',
    passwordResetError: 'Errore durante il reset della password',
    passwordResetErrorUnverified: 'Impossibile resettare la password. Verifica prima il tuo indirizzo email.',
    resendVerificationEmail: 'Reinvia Email di Verifica',
    verificationEmailSent: 'Email di verifica inviata!',
    verificationEmailError: 'Errore nell\'invio dell\'email di verifica',
    passwordMismatch: 'Le password non coincidono',
    passwordsDoNotMatch: 'Le password non coincidono',
    passwordTooShort: 'La password deve essere di almeno 6 caratteri',
    passwordMinLength: 'Per favore allunga questo testo a 6 caratteri o più (stai attualmente usando {current} caratteri).',
    fieldRequired: 'Questo campo è obbligatorio.',

    // Email Verification
    emailVerification: 'Verifica Email',
    verifyingEmail: 'Verifica del tuo indirizzo email in corso...',
    verifying: 'Verifica in corso...',
    emailNotVerified: 'Verifica la tua email prima di accedere. Controlla la tua casella di posta per il link di verifica.',

    // Google OAuth
    googleAuthentication: 'Autenticazione Google',
    processingGoogleAuth: 'Elaborazione dell\'autenticazione Google in corso...',
    processing: 'Elaborazione in corso...',
    googleAuthSuccess: 'Autenticazione Google completata con successo!',
    googleAuthFailed: 'Autenticazione Google fallita.',
    googleAuthFailedWithCredentials: 'Autenticazione Google fallita. Controlla le tue credenziali e riprova.',
    googleAuthCancelled: 'Autenticazione Google annullata o fallita.',
    googleNoCode: 'Nessun codice di autorizzazione ricevuto da Google.',
    googleAuthFailedMessage: 'Autenticazione Google fallita. Puoi riprovare o tornare al login.',
    tryAgain: 'Riprova'
};

export default auth;
